"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireWildcard(require("react"));
var _ErrorPrompt = require("../../complex/ErrorPrompt");
var _system = require("../../system");
var _eero = require("../../theme/eero");
var _index = require("../index");
var _excluded = ["id", "fontSize", "required", "analyticsName", "autoFocus", "content", "disabled", "errorMessage", "name", "placeholder", "resizable", "title", "unboundedWidth", "onBlur", "onChange", "onFocus", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_n08qv9tw3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/TextArea/TextArea.tsx";
  var hash = "a0c155783615d2d6fb5adc8ad77b916bf266a600";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/TextArea/TextArea.tsx",
    statementMap: {
      "0": {
        start: {
          line: 56,
          column: 21
        },
        end: {
          line: 74,
          column: 1
        }
      },
      "1": {
        start: {
          line: 63,
          column: 34
        },
        end: {
          line: 63,
          column: 87
        }
      },
      "2": {
        start: {
          line: 66,
          column: 24
        },
        end: {
          line: 66,
          column: 60
        }
      },
      "3": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "4": {
        start: {
          line: 77,
          column: 23
        },
        end: {
          line: 77,
          column: 62
        }
      },
      "5": {
        start: {
          line: 157,
          column: 42
        },
        end: {
          line: 217,
          column: 1
        }
      },
      "6": {
        start: {
          line: 177,
          column: 23
        },
        end: {
          line: 182,
          column: 3
        }
      },
      "7": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 60
        }
      },
      "8": {
        start: {
          line: 184,
          column: 2
        },
        end: {
          line: 216,
          column: 4
        }
      },
      "9": {
        start: {
          line: 219,
          column: 38
        },
        end: {
          line: 219,
          column: 96
        }
      },
      "10": {
        start: {
          line: 219,
          column: 49
        },
        end: {
          line: 219,
          column: 96
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 63,
            column: 22
          },
          end: {
            line: 63,
            column: 23
          }
        },
        loc: {
          start: {
            line: 63,
            column: 34
          },
          end: {
            line: 63,
            column: 87
          }
        },
        line: 63
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        },
        loc: {
          start: {
            line: 66,
            column: 24
          },
          end: {
            line: 66,
            column: 60
          }
        },
        line: 66
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 77,
            column: 11
          },
          end: {
            line: 77,
            column: 12
          }
        },
        loc: {
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 62
          }
        },
        line: 77
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 157,
            column: 42
          },
          end: {
            line: 157,
            column: 43
          }
        },
        loc: {
          start: {
            line: 176,
            column: 6
          },
          end: {
            line: 217,
            column: 1
          }
        },
        line: 176
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 178,
            column: 5
          }
        },
        loc: {
          start: {
            line: 178,
            column: 51
          },
          end: {
            line: 180,
            column: 5
          }
        },
        line: 178
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 219,
            column: 38
          },
          end: {
            line: 219,
            column: 39
          }
        },
        loc: {
          start: {
            line: 219,
            column: 49
          },
          end: {
            line: 219,
            column: 96
          }
        },
        line: 219
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 63,
            column: 34
          },
          end: {
            line: 63,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 55
          },
          end: {
            line: 63,
            column: 67
          }
        }, {
          start: {
            line: 63,
            column: 70
          },
          end: {
            line: 63,
            column: 87
          }
        }],
        line: 63
      },
      "1": {
        loc: {
          start: {
            line: 66,
            column: 24
          },
          end: {
            line: 66,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 42
          },
          end: {
            line: 66,
            column: 51
          }
        }, {
          start: {
            line: 66,
            column: 54
          },
          end: {
            line: 66,
            column: 60
          }
        }],
        line: 66
      },
      "2": {
        loc: {
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 46
          },
          end: {
            line: 77,
            column: 52
          }
        }, {
          start: {
            line: 77,
            column: 55
          },
          end: {
            line: 77,
            column: 62
          }
        }],
        line: 77
      },
      "3": {
        loc: {
          start: {
            line: 159,
            column: 2
          },
          end: {
            line: 159,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 159,
            column: 13
          },
          end: {
            line: 159,
            column: 17
          }
        }],
        line: 159
      },
      "4": {
        loc: {
          start: {
            line: 179,
            column: 24
          },
          end: {
            line: 179,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 24
          },
          end: {
            line: 179,
            column: 45
          }
        }, {
          start: {
            line: 179,
            column: 49
          },
          end: {
            line: 179,
            column: 58
          }
        }],
        line: 179
      },
      "5": {
        loc: {
          start: {
            line: 186,
            column: 7
          },
          end: {
            line: 198,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 7
          },
          end: {
            line: 186,
            column: 12
          }
        }, {
          start: {
            line: 186,
            column: 16
          },
          end: {
            line: 186,
            column: 18
          }
        }, {
          start: {
            line: 187,
            column: 8
          },
          end: {
            line: 197,
            column: 16
          }
        }],
        line: 186
      },
      "6": {
        loc: {
          start: {
            line: 194,
            column: 17
          },
          end: {
            line: 194,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 194,
            column: 28
          },
          end: {
            line: 194,
            column: 40
          }
        }, {
          start: {
            line: 194,
            column: 43
          },
          end: {
            line: 194,
            column: 52
          }
        }],
        line: 194
      },
      "7": {
        loc: {
          start: {
            line: 208,
            column: 15
          },
          end: {
            line: 208,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 208,
            column: 15
          },
          end: {
            line: 208,
            column: 22
          }
        }, {
          start: {
            line: 208,
            column: 26
          },
          end: {
            line: 208,
            column: 28
          }
        }],
        line: 208
      },
      "8": {
        loc: {
          start: {
            line: 210,
            column: 25
          },
          end: {
            line: 210,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 210,
            column: 39
          },
          end: {
            line: 210,
            column: 52
          }
        }, {
          start: {
            line: 210,
            column: 55
          },
          end: {
            line: 210,
            column: 79
          }
        }],
        line: 210
      },
      "9": {
        loc: {
          start: {
            line: 210,
            column: 25
          },
          end: {
            line: 210,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 210,
            column: 25
          },
          end: {
            line: 210,
            column: 30
          }
        }, {
          start: {
            line: 210,
            column: 34
          },
          end: {
            line: 210,
            column: 36
          }
        }],
        line: 210
      },
      "10": {
        loc: {
          start: {
            line: 213,
            column: 7
          },
          end: {
            line: 213,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 213,
            column: 7
          },
          end: {
            line: 213,
            column: 19
          }
        }, {
          start: {
            line: 213,
            column: 23
          },
          end: {
            line: 213,
            column: 61
          }
        }],
        line: 213
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a0c155783615d2d6fb5adc8ad77b916bf266a600"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_n08qv9tw3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_n08qv9tw3();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TextAreaBase = (cov_n08qv9tw3().s[0]++, /*#__PURE__*/(0, _base["default"])(_system.bricks.textarea, process.env.NODE_ENV === "production" ? {
  target: "e15tb3as1"
} : {
  target: "e15tb3as1",
  label: "TextAreaBase"
})("width:100%;height:180px;display:block;font-size:", _eero.fontSizesNamedWithUnits.s1, ";font-family:", _eero.fonts.sans, ";border-radius:", _eero.radii.roundedSquare, ";border:2px solid ", function (props) {
  cov_n08qv9tw3().f[0]++;
  cov_n08qv9tw3().s[1]++;
  return props.errorMessage ? (cov_n08qv9tw3().b[0][0]++, _eero.colors.red50) : (cov_n08qv9tw3().b[0][1]++, _eero.colors.neutrals40);
}, ";box-sizing:border-box;padding:15px 12px;resize:", function (props) {
  cov_n08qv9tw3().f[1]++;
  cov_n08qv9tw3().s[2]++;
  return props.resizable ? (cov_n08qv9tw3().b[1][0]++, 'initial') : (cov_n08qv9tw3().b[1][1]++, 'none');
}, ";&:disabled{background:", _eero.colors.neutrals10, ";color:", _eero.colors.neutrals100, ";opacity:0.6;cursor:not-allowed;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
var TextAreaWrapper = (cov_n08qv9tw3().s[3]++, /*#__PURE__*/(0, _base["default"])(_index.Box, process.env.NODE_ENV === "production" ? {
  target: "e15tb3as0"
} : {
  target: "e15tb3as0",
  label: "TextAreaWrapper"
})("width:", function (props) {
  cov_n08qv9tw3().f[2]++;
  cov_n08qv9tw3().s[4]++;
  return props.unboundedWidth ? (cov_n08qv9tw3().b[2][0]++, '100%') : (cov_n08qv9tw3().b[2][1]++, '350px');
}, ";@media (max-width: 768px){width:100%;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));

/**
 * The TextArea component allows you to easily create multi-line text inputs. It
 * directly maps to a textarea element.
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * `TextArea` components should be properly labeled for a11y. If you pass
 * `title`, the `TextArea` component will render a label with the correct a11y
 * attributes for you. If you do not pass `title`, make sure there is a visible
 * textual element near the `TextArea` component and pass the `id` of the
 * element as `aria-labeledby`. If for some reason you can't have a visible
 * label, pass `aria-label` instead.
 *
 * ###
 *
 * ✅ Pass
 *
 * <TextArea title="Example" placeholder="Placeholder" />
 *
 * <Box> <Text id="textarea-title">Example</Text> <TextArea
 * aria-labeledby="textarea-title" placeholder="Placeholder" /> </Box>
 *
 * // Not ideal but acceptable <TextArea aria-label="Example"
 * placeholder="Placeholder" />
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <TextArea placeholder="Placeholder" />
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * The `TextArea` component has built-in event tracking for impression, hover,
 * focus, and blur events. To track these events, consumers must pass down a
 * non-empty `analyticsName`. For more information on event tracking in bricks
 * components read the EDD.
 *
 * ####
 *
 * Impression events
 *
 * Impression events are tracked using the intersection observer API. A
 * impression event is triggered when the input component enters the viewport.
 *
 * ####
 *
 * Hover events
 *
 * Hover events are tracked by looking for a mouseenter event. A mouseenter
 * event is fired when a pointing device is initally moved so that its hotspot
 * is within the element at which the event was fired.
 *
 * ####
 *
 * Focus events
 *
 * An onFocus event occurs when an element gets focus.
 *
 * ####
 *
 * Blur events
 *
 * An onBlur event occurs when an element loses focus. This is the opposite of
 * an onFocus event.
 */
cov_n08qv9tw3().s[5]++;
var TextArea = function TextArea(_ref) {
  var id = _ref.id,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? (cov_n08qv9tw3().b[3][0]++, 's1') : _ref$fontSize,
    required = _ref.required,
    analyticsName = _ref.analyticsName,
    autoFocus = _ref.autoFocus,
    content = _ref.content,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    name = _ref.name,
    placeholder = _ref.placeholder,
    resizable = _ref.resizable,
    title = _ref.title,
    unboundedWidth = _ref.unboundedWidth,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_n08qv9tw3().f[3]++;
  var handleChange = (cov_n08qv9tw3().s[6]++, (0, _react.useCallback)(function (e) {
    cov_n08qv9tw3().f[4]++;
    cov_n08qv9tw3().s[7]++;
    onChange(e, name, (cov_n08qv9tw3().b[4][0]++, e.currentTarget.value) || (cov_n08qv9tw3().b[4][1]++, undefined));
  }, [name, onChange]));
  cov_n08qv9tw3().s[8]++;
  return /*#__PURE__*/_react["default"].createElement(TextAreaWrapper, {
    className: 'od-multi-line-input',
    unboundedWidth: unboundedWidth
  }, (cov_n08qv9tw3().b[5][0]++, title) && (cov_n08qv9tw3().b[5][1]++, id) && (cov_n08qv9tw3().b[5][2]++, /*#__PURE__*/_react["default"].createElement(_index.Label, {
    htmlFor: id,
    id: "".concat(id, "-label"),
    fontSize: fontSize,
    required: required,
    display: "block",
    pb: [2, 3],
    color: disabled ? (cov_n08qv9tw3().b[6][0]++, 'neutrals70') : (cov_n08qv9tw3().b[6][1]++, undefined)
  }, title)), /*#__PURE__*/_react["default"].createElement(TextAreaBase
  // eslint-disable-next-line jsx-a11y/no-autofocus
  , _extends({
    autoFocus: autoFocus,
    className: "form-input",
    disabled: disabled,
    name: name,
    onChange: handleChange,
    placeholder: placeholder,
    resizable: resizable,
    value: (cov_n08qv9tw3().b[7][0]++, content) || (cov_n08qv9tw3().b[7][1]++, ''),
    errorMessage: errorMessage,
    "aria-labelledby": (cov_n08qv9tw3().b[9][0]++, title) && (cov_n08qv9tw3().b[9][1]++, id) ? (cov_n08qv9tw3().b[8][0]++, "".concat(id, "-label")) : (cov_n08qv9tw3().b[8][1]++, props['aria-labelledby'])
  }, props)), (cov_n08qv9tw3().b[10][0]++, errorMessage) && (cov_n08qv9tw3().b[10][1]++, /*#__PURE__*/_react["default"].createElement(_ErrorPrompt.ErrorPrompt, {
    message: errorMessage
  })), /*#__PURE__*/_react["default"].createElement(HelpText, null, children));
};
cov_n08qv9tw3().s[9]++;
var HelpText = function HelpText(props) {
  cov_n08qv9tw3().f[5]++;
  cov_n08qv9tw3().s[10]++;
  return /*#__PURE__*/_react["default"].createElement(_index.Text, _extends({
    fontSize: "s1",
    mt: 3,
    mb: 0
  }, props));
};
var _default = exports["default"] = TextArea;